import { isEmpty } from 'lodash';
import { BaseTicketController } from '../../../../common/base/ticketController';
import { financesStateName } from '../finances/finances.state';

export class WaitForTransferringController extends BaseTicketController {
  constructor(
    controllerService,
    ticketService,
    receivingCreateRequestStateName,
    $q,
  ) {
    'ngInject';
    super({
      controllerService,
      ticketService,
      receivingCreateRequestStateName,
      $q,
    });
  }

  get deadline() {
    return this.isFeatureActive(
      this.FeatureNames.FF_HIDE_DEADLINE_FOR_WAITING_FOR_TRANSFERRING,
    )
      ? null
      : this.ticket.nextDeadlineInBankDays;
  }

  get hasUploadPrivacyCheckbox() {
    return this.isFeatureActive(
      this.FeatureNames.FF_BALANCE_LIST_UPLOAD_PRIVACY_COMPLIANT,
    );
  }

  get documentTypes() {
    return this.config.ui.waitForTransferringUploadOptions;
  }

  selectUploadAction(uploadAction) {
    this.selectedUploadAction = uploadAction;
    this.uploadPrivacyConfirmed = false;
  }

  $onInit() {
    super.$onInit();

    this.model = {};

    // Set default value for the entry date to today
    this.model.entryDate = new Date();

    // When the ticket is rejected, navigate away
    if (this.isRejected()) {
      this.navigateToRejected();
    }

    // Set production flag
    this.isProduction = this.envService.isProduction();
  }

  isRejected() {
    return this.ticketService.hasStatus(
      this.ticket,
      this.ticketService.TicketStates.RECEIVED_REJECTION,
    );
  }

  canReject() {
    return this.ticketService.hasStatus(
      this.ticket,
      this.ticketService.TicketStates.RECEIVED_REJECTION_DOCUMENT,
    );
  }

  openRejected() {
    this.reject = true;
  }

  uploadRejection(file) {
    const { entryDate } = this.model;
    return this.ticketService.uploadRejection(this.ticket.id, file, entryDate);
  }

  submitTransactionData() {
    return this.ticketService
      .uploadTransactionData(this.ticket.id, this.uploadedTransactionData[0])
      .busy(this, 'isTransactionDataUploadBusy');
  }

  get hasTransactionData() {
    return !isEmpty(this.uploadedTransactionData);
  }

  get hasMiscData() {
    return !isEmpty(this.uploadedMiscData);
  }

  submitMiscData() {
    return this.ticketService
      .uploadMiscDocument(this.ticket.id, this.uploadedMiscData[0])
      .busy(this, 'isMiscUploadBusy')
      .then(() => {
        this.uploadedMiscData = [];
      });
  }

  get ticketStatusTitle() {
    return this.ticket.warrantShipmentSkipped
      ? 'app.waitForTransferring.warrantShipmentSkipped.title'
      : 'app.waitForTransferring.title';
  }

  get ticketStatusBody() {
    return this.ticket.warrantShipmentSkipped
      ? 'app.waitForTransferring.warrantShipmentSkipped.body'
      : 'app.waitForTransferring.body';
  }

  navigateToRejected() {
    this.ticketService.viewStatusChanged(this.ticket.id, {
      reason: this.ticket.status,
      status: 'error',
      icon: 'fa-ban',
      cta: () => this.duplicate(),
      ctaTitle: 'app.ticket.duplicate',
    });
  }

  navigateToFinances() {
    this.go(financesStateName);
  }

  rejectReceiving() {
    return this.ticketService
      .rejectReceiving(this.ticket.id)
      .busy(this, 'isRejectBusy')
      .then(() => this.navigateToRejected());
  }

  duplicate() {
    const { ticketService, receivingCreateRequestStateName, appCache, ticket } =
      this;
    const { id, requestType } = ticket;
    ticketService
      .closeTicket(requestType, id)
      .busy(this, 'isDuplicateBusy')
      .then(() => {
        appCache.put('duplicateTicket', ticket.formValues);
        this.go(receivingCreateRequestStateName);
      });
  }

  simulateFinances() {
    const { ticketService, ticket } = this;
    this.simulateFinancesBusy = true;
    ticketService.simulateFinancesDataCaptured(ticket.id).then((result) => {
      this.simulateFinancesBusy = false;
      ticketService.getRefreshResponse(ticket.id)(result);
    });
  }

  simulateFinancesLegacy() {
    const { ticketService, ticket } = this;
    this.simulateFinancesBusy = true;
    ticketService.simulateFinancesDataCaptured(ticket.id).then((result) => {
      this.simulateFinancesBusy = false;
      ticketService.getRefreshResponse(ticket.id)(result);
    });
  }
}
